export default "/assets/3ab0502d6136886180cdae3e714e30a3.woff";